// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__+oSwO","spinner":"SmallLoader_spinner__84I1J","spinner-d3o0rx":"SmallLoader_spinner-d3o0rx__A1uqO"};